<div class="container">

  <mat-tab-group  [selectedIndex]="selected.value" (selectedTabChange)="selected.setValue($event.index)">

  <mat-tab label="Historial viajes">
    <div  class="mt-5">
      <data-table

      title='Historial viajes'
      [columns]='historyTravelColumnsTable'
      [configuration]='historyTravelConfigurationTable'
      [reloadTable]='reloadhistoryTravelTable'
      [params]='[]'
      [url]='EndpointDictionary.Travelhistory.TABLE_TRAVEL_HISTORY'
      (view)='viewDetail($event)'      
      [headerFilters]="headerFilters"
      [headerFileXlsm]="headerFileTableXlsm"
      [xslxParams]="xslxParams"
      [xslxTitleFields]="['code','routeName']"
      [xslxSheetNameFields]="['code','routeName']"
      xslxBodyFields="checkpoints"
      ></data-table>

    </div>
  </mat-tab>

  <mat-tab *ngIf="selected.value == 1" label="Detalle">
    <app-travel-history-summary
    [travelHistoryId]='travelHistoryId'
    >
    </app-travel-history-summary>

  </mat-tab>


  </mat-tab-group>




</div>
